module.exports = __webpack_public_path__ + "static/media/no_pro_connections.7fb3de40.png";